<script>
import { GlTabs, GlTab, GlBadge } from '@gitlab/ui';
import { numberToMetricPrefix } from '~/lib/utils/number_utils';
import { formatNumber } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';

export default {
  name: 'IssuableTabs',
  components: {
    GlTabs,
    GlTab,
    GlBadge,
  },
  mixins: [glSlotsMixin],
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    tabCounts: {
      type: Object,
      required: false,
      default: null,
    },
    currentTab: {
      type: String,
      required: true,
    },
    truncateCounts: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxCount: {
      type: Number,
      required: false,
      default: null,
    },
  },
  emits: ['click'],
  methods: {
    isTabActive(tabName) {
      return tabName === this.currentTab;
    },
    isTabCountNumeric(tab) {
      return Number.isInteger(this.tabCounts[tab.name]);
    },
    formatNumber(count) {
      if (this.maxCount) {
        return count > this.maxCount ? `${this.maxCount}+` : count;
      }

      return this.truncateCounts ? numberToMetricPrefix(count) : formatNumber(count);
    },
  },
};
</script>

<template>
  <div v-if="tabs.length > 0 || glSlots()['nav-actions']" class="top-area">
    <gl-tabs
      v-if="tabs.length > 0"
      class="mobile-separator issuable-state-filters gl-m-0 gl-flex gl-grow gl-p-0 [&_.gl-tabs-wrapper]:gl-border-0"
      nav-class="gl-border-b-0"
    >
      <gl-tab
        v-for="tab in tabs"
        :key="tab.id"
        :active="isTabActive(tab.name)"
        @click="$emit('click', tab.name)"
      >
        <template #title>
          <span :title="tab.titleTooltip" :data-testid="`${tab.name}-issuables-tab`">
            {{ tab.title }}
          </span>
          <gl-badge
            v-if="tabCounts && isTabCountNumeric(tab)"
            variant="neutral"
            class="gl-tab-counter-badge"
          >
            {{ formatNumber(tabCounts[tab.name]) }}
          </gl-badge>
        </template>
      </gl-tab>
    </gl-tabs>
    <div class="nav-controls gl-justify-end">
      <slot name="nav-actions"></slot>
    </div>
  </div>
</template>
